







import { defineComponent } from '@vue/composition-api';
import AdvCommonContainer from '@/components/adv-components/adv-common-container';
import { HOME_ADV_ID_MAP } from '@/pages/home/constant';

export default defineComponent({
  name: 'ActionBtnCornerAdv',
  components: {
    AdvCommonContainer,
  },
  setup() {
    return {
      HOME_ADV_ID_MAP,
    };
  },
});
